var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"flat":"","elevation":"5"}},[_c('v-lazy',{attrs:{"min-height":"400","options":{
      threshold: 0.1,
    },"transition":"fade-transition"},model:{value:(_vm.lazyActive),callback:function ($$v) {_vm.lazyActive=$$v},expression:"lazyActive"}},[_c('Charts',{attrs:{"option":_vm.interestDistributed}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }